// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import {
    ApiHandler,
    createHandlerChainRunner,
    Handler,
    HasOnError,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";
import {
    getUserHasAccessToPageInformation,
    UserHasAccessToPageInformationModel,
} from "@stoneage/App/Services/PageAccess/UserHasAccessToPageService";
import { ApiParameter } from "@insite/client-framework/Services/ApiService";

export interface UserHasAccessToPageApiParameter extends ApiParameter {
    pageName?: string;
}

type HandlerType = ApiHandler<
    UserHasAccessToPageApiParameter & HasOnSuccess<UserHasAccessToPageInformationModel> & HasOnError,
    UserHasAccessToPageInformationModel
>;

export const PopulateApiParameters: HandlerType = props => {
    props.apiParameter = props.parameter;

    if (!props.apiParameter.pageName) {
        return false;
    }
};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        props.apiResult = await getUserHasAccessToPageInformation(props.apiParameter.pageName!);
    } catch (e) {
        props.parameter.onError?.();
        return false;
    }
};

export const CompleteLoadHasAccessToPage: HandlerType = props => {
    props.apiResult.hasAccess = props.apiResult.statusCode === 200;
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    props.parameter.onSuccess?.(props.apiResult);
};

export const chain = [PopulateApiParameters, RequestDataFromApi, CompleteLoadHasAccessToPage, ExecuteOnSuccessCallback];

const loadUserHasAccessToPageData = createHandlerChainRunner(chain, "LoadUserHasAccessToPageData");
export default loadUserHasAccessToPageData;
